import { TLang, TCurrency, TStartReservationSchema } from '@/types'

import { yerevanAirportSlug, yerevanSlug } from './utils'

export const APP_NAME = 'Alamo'
export const LANG_KEY = '@lang'
export const CURRENCY_KEY = '@currency'
export const START_KEY = '@reservation_start'
export const CONFIRMED_KEY = '@reservation_confirmed'

export const API_ENDPOINT = `${process.env.NEXT_PUBLIC_HTTP_PROTOCOL}://${process.env.NEXT_PUBLIC_API_ENDPOINT}`

export const DEFAULT_LANG = (process.env.NEXT_PUBLIC_DEFAULT_LANG ||
  'en') as TLang

export const APP_LANGUAGES: TLang[] = ['en', 'ru']

export const APP_CURRENCIES: TCurrency[] = [
  {
    name: 'USD',
    symbol: '$',
  },
  {
    name: 'EUR',
    symbol: '€',
  },
  {
    name: 'RUB',
    symbol: '₽',
  },
]

export const DEFAULT_CURRENCY = APP_CURRENCIES[0].name

export const DATE_FORMAT = 'YYYY-MM-DD'

// timeout checking in milliseconds
export const TIMEOUT_CHECK_INTERVAL =
  +(process.env.NEXT_PUBLIC_INTERVAL_FOR_CHECKING_TIMEOUT || 1) * 1000
// timeout in milliseconds
export const TIMEOUT = +(process.env.NEXT_PUBLIC_TIMEOUT || 1200) * 1000
export const SHOW_TIMEOUT_POPUP =
  +(process.env.NEXT_SHOW_TIMEOUT_POPUP || 900) * 1000

export const locations: Record<
  typeof yerevanSlug | typeof yerevanAirportSlug,
  Pick<
    TStartReservationSchema,
    | 'pickUpLatitude'
    | 'pickUpLocation'
    | 'pickUpLongitude'
    | 'pickUpStationCode'
  >
> = {
  [yerevanAirportSlug]: {
    pickUpLatitude: '40.152495',
    pickUpStationCode: 'EVNT71',
    pickUpLongitude: '44.399857',
    pickUpLocation: 'Yerevan Zvartnots Intl. Airport',
  },
  [yerevanSlug]: {
    pickUpLatitude: '40.18111',
    pickUpLongitude: '44.51361',
    pickUpStationCode: undefined,
    pickUpLocation: 'Yerevan, AM (Yerevan)',
  },
}
